import {ReactComponent} from '../app'
import {Row, Col} from 'antd'
import React from 'react'
import FixedHeader from '../components/layout/FixedHeader'
import PrivacyPolicyContent from '../components/parts/PrivacyPolicyContent'

export default class PrivacyPolicyPage extends ReactComponent {
  render() {
    return (
      <>
        <FixedHeader/>
        <section className="container full-height centered simple-text-page">
          <Row align="center" justify="center" gutter={[20, 20]}>
            <Col span={24}>
              <PrivacyPolicyContent />
            </Col>
          </Row>
        </section>
      </>
    )
  }
}